/**
 * cart-drawer.js — Mavin Parfum
 * Debug + AJAX cart operations.
 */
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.onClick);

    document.addEventListener('click', e => {
      if (e.target.closest('[data-cart-toggle]')) {
        e.preventDefault();
        this.open();
      }
    });

    document.addEventListener('submit', e => {
      const form = e.target;

      if (form.matches('form[action*="/cart/add"]')) {
        e.preventDefault();
        this.addToCart(form);
      }
    });
  }

  onClick(e) {
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) {
      this.close();
      return;
    }

    const inc = e.target.closest('[data-cart-inc]');
    const dec = e.target.closest('[data-cart-dec]');
    const remove = e.target.closest('[data-cart-remove]');

    if (inc) this.updateQty(inc.dataset.lineKey, '+1');
    if (dec) this.updateQty(dec.dataset.lineKey, '-1');
    if (remove) this.updateQty(remove.dataset.lineKey, 0);
  }

  onKeydown(e) {
    if (e.key === 'Escape' && !this.hidden) this.close();
  }

  open() {
    this.hidden = false;
    requestAnimationFrame(() => this.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this.onKeydown);

    const focusable = this.querySelector('[data-cart-close]');
    if (focusable) focusable.focus();
  }

  close() {
    this.classList.remove('is-open');
    setTimeout(() => {
      this.hidden = true;
    }, 350);

    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.onKeydown);
  }

  async addToCart(form) {
    const formData = new FormData(form);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      const data = await res.json();

      if (!res.ok) {
        const message = data.description || data.message || 'Prodotto non disponibile.';
        alert('Errore Shopify: ' + message);
        console.error('Errore aggiunta carrello:', data);
        return;
      }

      await this.refresh();
      this.open();

    } catch (err) {
      alert('Errore tecnico durante aggiunta al carrello.');
      console.error(err);
    }
  }

  async updateQty(key, qtyOrDelta) {
    let quantity;

    if (qtyOrDelta === '+1' || qtyOrDelta === '-1') {
      const input = this.querySelector(`[data-cart-qty][data-line-key="${key}"]`);
      const current = parseInt(input.value, 10) || 0;
      quantity = qtyOrDelta === '+1' ? current + 1 : Math.max(0, current - 1);
    } else {
      quantity = parseInt(qtyOrDelta, 10);
    }

    const body = { id: key, quantity };

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });

      if (!res.ok) throw new Error('Change failed');

      await this.refresh();
    } catch (err) {
      console.error(err);
    }
  }

  async refresh() {
    try {
      const res = await fetch(`${window.location.pathname}?sections=cart-drawer`);
      const json = await res.json();
      const markup = json['cart-drawer'];

      if (markup) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(markup, 'text/html');
        const newDrawer = doc.querySelector('cart-drawer');

        if (newDrawer) this.innerHTML = newDrawer.innerHTML;
      }

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });

    } catch (err) {
      console.error(err);
    }
  }
}

customElements.define('cart-drawer', CartDrawer);